<template>
	<div class="sign-in-container form-container">
		<div class="center-flex-inline">
			<p>New here?&nbsp;&nbsp;&nbsp;<span class="link" @click="handleClickSignUp">Sign up</span> now!</p>
		</div>
		<div class="contact-form">
			<div class="contact-field" :class="updatePhoneClass()">
				<BaseIcon
					class="input-field-icon icon-mobile"
					icon="mobile"
					:isCustom="true"
					size="1x"/>
				<input
					:class="(liveValidate) ? 'is-success' : 'is-danger'"
					class="input text-input has-icon"
					type="tel"
					placeholder="Mobile Number"
					v-model="phone"/>
			</div>
			<div class="terms-wrapper">
				<label class="control control--checkbox cust-radio" ref="leaveAtDoorCheckbox">
					<input
						type="checkbox"
						role="checkbox"
						aria-label="accept terms of service"
						v-model="acceptTerms"
					/>
					<div class="control__indicator checkbox"></div>
					<p class="is-size-7">
						I agree to the <a class="red-link" target="_blank" href="https://www.touchpoint.io/terms">Terms of Service</a>. Learn about how we use and protect your data in our <a class="red-link" target="_blank" href="https://www.touchpoint.io/privacy">Privacy Policy</a>
					</p>
				</label>
			</div>
			<div class="contact-field">
				<BaseButton
					:classNames="['button--modifier', 'input-field-button']"
					title="Sign In"
					type="scaleable-fixed-square"
					:disabled="!validPhone || !acceptTerms"
					@click="handleClickSignIn"/>
			</div>
			<a class="small-link" @click.prevent="_navigateToGuestForm">or continue as guest</a>
		</div>
	</div>
</template>

<script>
	// TODO should not have to extend this vue
	import PhonelessUserCollapsible from '@Account/PhonelessUserCollapsible.vue';
	import ContactDetailsVue from '@Account/ContactDetails/ContactDetails.vue';
	import contactDetailsMixin from '@Mixin/contactDetailsMixin';
	import loginMixin from '@Mixin/loginMixin';
	import headerMixin from '@Mixin/headerMixin';
	export default {
		mixins: [
			contactDetailsMixin,
			loginMixin,
			headerMixin,
		],
		components: {
			'phoneless-user-collapsible': PhonelessUserCollapsible,
		},
		props: {},
		data() {
			return {
				requestingLogin: false,
				acceptTerms: false
			};
		},
		methods: {
			handleClickSignIn() {
				this.requestingLogin = true;
				this.signIn();
			},
			handleClickSignUp() {
				this._navigateToSignUp();
			},
			signIn() {
				this.sendLoginRequest().then((response) => {
					this.initialLoginSuccess(response);
				});
			},
		},
		mounted() {
			this._setHeaderTitle('Sign In');
		}
	}
</script>

<style lang="scss" scoped>
	@import 'commonStyle/checkout';
	@import 'commonStyle/contactForm';
	.small-link {
		width: 100%;
		text-align: right;
		text-decoration: underline;
	}
	@include mobile {}
	@include desktop {}
	@include tablet {}
	.terms-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 20px;
		label.control {
			max-width: 320px;
			margin-bottom: 0;
			padding-bottom: 0;
			.checkbox {
				top: 10px;
			}
			.red-link {
				color: red;
				text-decoration: underline;
				cursor: pointer;
			}
			p {
				text-align: left;
				margin-left: 10px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/account/SignIn.vue